let SfcUtil = {

	convertContentToObject: (pageObject) => {
		let contents = {}
		for (var value of pageObject){
			if (value.value) {
				contents[value.name] = value.value.replace("<sfc-best-529-plans-widget></sfc-best-529-plans-widget>","")
			}
		}
		return contents
	},


	utcDateToHuman: (date) => {
		try {
			const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
			let day, month, year
			if (date){
				if (typeof(date) == "string"){
					const lDate = date.split(" ")[0]
					const arrDate = lDate.split("-")
					year = parseInt(arrDate[0])
					month = parseInt(arrDate[1]) - 1
					day = parseInt(arrDate[2])
				}
				else if (typeof(date) == "number"){
					const internalDate = new Date(date)
					day = internalDate.getDate()
					month = internalDate.getMonth()
					year = internalDate.getFullYear()
				}
				else if (typeof(date) == "object" && date.getFullYear){
					day = date.getDate()
					month = date.getMonth()
					year = date.getFullYear()
				}
				return `${months[month]} ${day}, ${year}`
			}
		}
		catch(err){
		}
		return ""
	},

	isAPlanToCompare: (plans, plan) => {
		for(let p of plans){
			if(p.id == plan.id){
				return true
			}
		}
		return false
	},

	isInternetExplorer: () => {
		var ua = window.navigator.userAgent;
		console.log("user agent -->", ua)
		var msie = ua.indexOf('MSIE ');
		if (msie > 0) {
			// IE 10 or older => return version number
			// return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
			return true
		}

		var trident = ua.indexOf('Trident/');
		if (trident > 0) {
			// IE 11 => return version number
			// var rv = ua.indexOf('rv:');
			// return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
			return true
		}

		var edge = ua.indexOf('Edge/');
		if (edge > 0) {
			// Edge (IE 12+) => return version number
			// return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
			return true
		}

		// other browser
		return false;
	}

}

export default SfcUtil


